import React, { useState } from 'react'
import SlideUpWrapper from '../../../../../components/Transitions/SlideUpWrapper'
import Breadcrumb from '../../../../../components/Verifier/breadcrumb/BreadCrumb'
import Loader from '../../../../../components/Loader'
import Style from '../../../VerifierInternalDashboard/index.module.css'
import form from './CreateVerifierForm.module.css';
import { useLocation, useNavigate } from 'react-router-dom'
import cogoToast from 'cogo-toast-react-17-fix'
import { isInternalUser } from '../../../../../Utils/helper'
import CustomDropDown from '../../../../../components/CustomDropDown'
const FormType = () => {

    const [loading, setLoading] = useState(false);
    const [formName, setFormName] = useState('')
    const [selectedOption, setselectedOption] = useState('');
    const [formCategory, setFormCategory]=useState("Select Verifier Type")
    const location = useLocation();
    const navigateBack = location.state?.flow || false

    const isInternal = isInternalUser()

    const navigate = useNavigate();
    // console.log(selectedOption);

    const handleSubmit = (e) => {
        e.preventDefault();
    
        if (!formName.trim()) {
            return cogoToast.error("Enter Template name");
        }
    
        if (!selectedOption) {
            return cogoToast.error("Please Select some Value");
        }
        if (formCategory=="Select Verifier Type") {
            return cogoToast.error("Please Verifier Type");
        }
    
        const categoryMap = {
            General: "general",
            Employment: "employment",
        };
    
        if (selectedOption === "1" || selectedOption === "2") {
            const stateName = selectedOption === "1" ? "Verification fields" : "Verification documents";
            const form_category = categoryMap[formCategory] || "";
    
            navigate("../verification-fields/", {
                state: { state: stateName, formName, form_category },
            });
        }
    }
    function handleDocumentChange(e) {
        setFormCategory(e)
    }
    return (
        <>
            <div style={{ width: "100%" }}>
                <SlideUpWrapper direction='slide-left'>
                    {
                        isInternal ? <div className='topTitleBar topTitleBarText'>Create new Form</div> : <Breadcrumb pos={1} category={"verifier"} title={"Create Form"} />
                    }
                    <Loader isOpen={false} />
                    <form onSubmit={handleSubmit}>
                        <div className={Style.modalBody}>
                            <div style={{display:"flex", flexDirection:"column"}}>
                            <div className={Style.modalInput}>
                                <label>Template Name</label>
                                <input placeholder='My Form' value={formName} onChange={e => setFormName(e.target.value)} />
                            </div>
                            <div className={Style.modalInput} style={{display:"flex", alignItems:"center"}}>
                            <label>Verifier Type</label>
                                <CustomDropDown list={["General", "Employment"]} selectedOption={formCategory}onSelect={e=>handleDocumentChange(e)}/>
                            </div>
                            </div>
                            <div className={form.Container}>
                                <div className={Style.radioBtnWrapper}>
                                    Select how you want to add check
                                    {formCategory==="Employment"?null:
                                    <label onClick={e => { }}>
                                        <div className={Style.radioBtn}>
                                            <span className={Style.label}>
                                                <input type='radio' name='uploadtype' value={1} onChange={(e) => setselectedOption(e.target.value)} />
                                                Select by Data fields
                                            </span>
                                            <p className={Style.desc}>Ideal for quick start</p>
                                        </div>
                                    </label>}
                                    <label onClick={e => { }}>
                                        <div className={Style.radioBtn}>
                                            <span className={Style.label}>
                                                <input type='radio' name='uploadtype' value={2} onChange={(e) => setselectedOption(e.target.value)} />
                                                Select by Documents
                                            </span>
                                            <p className={Style.desc}>Add entire document with checks</p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {/* <div className={Style.btnWrapper}> */}

                        {loading ? <ShimmerLoader mt="1.5rem" height='3rem' width="9rem" br="10px" /> :
                            <button type='submit' className='btn btn-primary' style={{ width: "12%", marginTop: "20px" }}>Continue</button>}
                    </form>

                    {/* <button className='btn btn-primary' type='submit' onClick={e => handleForm(formName)}>Continue</button> */}
                    {/* </div> */}
                </SlideUpWrapper>
            </div>
        </>
    )
}

export default FormType;
